export default __webpack_public_path__ + "static/media/ill-success.718de581.svg";